import { React, useEffect, useRef, Link } from "../../libraries";


const MobileCategorySection = ({
    subCategoryClickVisible,
    handleCategoryClickFun,
    items,
    onCategoryClick,
    subCategoriesDatas,
    onSubCategoryClick,
    handleMouseLeave,
    setTitle,
    setIsBackBtn,
    activeCategoryId,
    setActiveCategoryId,
}) => {
    const selectedLanguage = localStorage.getItem("i18nextLng");
    const submenu1Ref = useRef({});

    useEffect(() => {
        submenu1Ref.current = {};
    }, []);

    useEffect(() => {
        let lastScrollTop = 0;
        const delta = 5;
        const headerElement = document.querySelector("header");
        const navbarHeight = headerElement.offsetHeight;

        const handleScroll = () => {
            const st = window.scrollY;
            if (Math.abs(lastScrollTop - st) <= delta) return;

            if (st > lastScrollTop && st > navbarHeight) {
                headerElement.classList.remove("nav-down");
                headerElement.classList.add("nav-up");
            } else {
                if (st + window.innerHeight < document.documentElement.scrollHeight) {
                    headerElement.classList.remove("nav-up");
                    headerElement.classList.add("nav-down");
                }
            }
            lastScrollTop = st;
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    const showSubMenu = (categoryId, title, titleInThai) => {
        setTitle(selectedLanguage === "en" ? title : titleInThai);
        setActiveCategoryId(categoryId);
        setIsBackBtn(true); 
    };

    return <>
        <ul className="menu-main">
            {!activeCategoryId && items.map((item) => (
                <li
                    key={item.id}
                    className="menu-item-has-children"
                    onClick={(e) => {
                        !subCategoryClickVisible
                            ? handleCategoryClickFun(
                                e,
                                item.name_en,
                                item.name_en,
                                item.name_thai
                            )
                            : showSubMenu(item.id, item.name_en, item.name_thai);
                    }}
                    onMouseEnter={() =>
                        onCategoryClick(item.id, item.name_en, item.name_thai)
                    }
                    onMouseLeave={() => handleMouseLeave()}
                >
                    <Link className="category">
                        {selectedLanguage === "thai" ? item.name_thai : item.name_en}
                        &nbsp;&nbsp;<i className="bi bi-chevron-down"></i>
                    </Link>
                </li>
            ))}
            {activeCategoryId && (
                <div className="sub-menu single-column-menu mobile-view-sub-category-list">
                    <ul className="submenu-main">
                        {subCategoriesDatas.map((subItem) => (
                            <li
                                key={subItem.id}
                                className="menu-item-has-children colorBlack "
                                onClick={(e) =>
                                    onSubCategoryClick(
                                        e,
                                        subItem.id,
                                        subItem.name_en,
                                        subItem.name_thai
                                    )
                                }
                            >
                                <Link>
                                    {selectedLanguage === "thai" ? subItem.name_thai : subItem.name_en}
                                </Link>
                            </li>
                        ))}
                    </ul>
                </div>
            )}
        </ul>
    </>
}

export default MobileCategorySection;